import React from "react";
import ReactPlayer from "react-player";

export default function MainBgm() {
  return (
    <ReactPlayer
      url="https://watalk-bgm.s3-ap-northeast-1.amazonaws.com/What+is+this+about+_(demo).m4a"
      playing={true}
      loop={true}
      width={0}
      height={0}
    ></ReactPlayer>
  );
}
